var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalAjoutProduitComplementaire",
      attrs: {
        size: "xl",
        scrollable: "",
        title: _vm.titreModal,
        "ok-title": _vm.titreBoutonOk,
        "cancel-title": "Annuler",
        "ok-disabled": !_vm.ajouterOK || !_vm.produitEstModifiee,
        "no-close-on-backdrop": ""
      },
      on: {
        ok: function($event) {
          return _vm.enregistrerProduit()
        },
        show: function($event) {
          return _vm.initialiserModale()
        }
      }
    },
    [
      _c("div", { staticStyle: { display: "inline" } }, [
        _c("div", { staticClass: "container-fluid card card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", [_vm._v("Famille du produit")]),
                _c("v-select", {
                  attrs: {
                    id: "selFamille",
                    disabled: true,
                    options: _vm.optionsFamilles,
                    value: "valeur",
                    label: "texte",
                    clearable: false
                  },
                  model: {
                    value: _vm.familleSelect,
                    callback: function($$v) {
                      _vm.familleSelect = $$v
                    },
                    expression: "familleSelect"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", { staticClass: "push-right-2rem" }, [
                  _vm._v("Fournisseur")
                ]),
                _c("v-select", {
                  attrs: {
                    disabled: true,
                    options: _vm.optionsFournisseurs,
                    value: "valeur",
                    label: "texte",
                    clearable: false
                  },
                  model: {
                    value: _vm.fournisseurSelect,
                    callback: function($$v) {
                      _vm.fournisseurSelect = $$v
                    },
                    expression: "fournisseurSelect"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4 form-group" },
              [
                _c("label", [_vm._v("Ingrédient")]),
                _c("RechercheCompleteProduits", {
                  ref: "refChercherIngredient",
                  attrs: {
                    disabled: _vm.rechercheIngredientDisabled,
                    chercherIngredients: true,
                    chercherProduits: true,
                    afficherPrix: false,
                    initValeur: _vm.vueProduitComplementaire.ingredient
                  },
                  on: {
                    input: function($event) {
                      _vm.key++
                      _vm.majIngredientSelect()
                    },
                    reset: function($event) {
                      return _vm.resetIngredient()
                    }
                  },
                  model: {
                    value: _vm.ingredientSelect,
                    callback: function($$v) {
                      _vm.ingredientSelect = $$v
                    },
                    expression: "ingredientSelect"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-8 form-group" }, [
              _c("label", { staticClass: "push-right-2rem" }, [
                _vm._v("Désignation")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.vueProduitComplementaire.designation,
                    expression: "vueProduitComplementaire.designation",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  disabled: !_vm.mercurialeModifiable,
                  type: "text",
                  title: "Description du produit pour le fournisseur"
                },
                domProps: { value: _vm.vueProduitComplementaire.designation },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.vueProduitComplementaire,
                        "designation",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              !_vm.vueProduitComplementaire.designation
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-3 form-group" }, [
              _c("label", [_vm._v("Marque")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.vueProduitComplementaire.marque,
                    expression: "vueProduitComplementaire.marque",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { disabled: !_vm.mercurialeModifiable, type: "text" },
                domProps: { value: _vm.vueProduitComplementaire.marque },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.vueProduitComplementaire,
                        "marque",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-3 form-group" }, [
              _c("label", [_vm._v("Référence")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.vueProduitComplementaire.reference,
                    expression: "vueProduitComplementaire.reference",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { disabled: !_vm.mercurialeModifiable, type: "text" },
                domProps: { value: _vm.vueProduitComplementaire.reference },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.vueProduitComplementaire,
                        "reference",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _c("div", [_vm._v(" ")])
            ]),
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", [_vm._v("Allergènes")]),
                _c("MultiSelect", {
                  attrs: {
                    items: _vm.optionsAllergenes,
                    itemText: "valeur",
                    itemValue: "id",
                    emptyText: "Tous les allergènes ont été ajoutés"
                  },
                  on: {
                    change: function($event) {
                      _vm.key++
                    }
                  },
                  model: {
                    value: _vm.vueProduitComplementaire.allergenesMajeurs,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.vueProduitComplementaire,
                        "allergenesMajeurs",
                        $$v
                      )
                    },
                    expression: "vueProduitComplementaire.allergenesMajeurs"
                  }
                }),
                !_vm.vueProduitComplementaire.allergenesMajeurs ||
                _vm.vueProduitComplementaire.allergenesMajeurs.length === 0
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Ce champ est requis")
                    ])
                  : _vm.allergenesKO
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(
                        "Vous ne pouvez pas sélectionner 'Aucun Allergène' avec d'autres allergènes"
                      )
                    ])
                  : _c("div", [_vm._v(" ")])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("PCB")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("InputNumber", {
                    staticStyle: { "margin-right": "2px" },
                    attrs: {
                      disabled: !_vm.mercurialeModifiable,
                      typeFiltre: "quantite"
                    },
                    on: {
                      input: function($event) {
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.vueProduitComplementaire.pcb,
                      callback: function($$v) {
                        _vm.$set(_vm.vueProduitComplementaire, "pcb", $$v)
                      },
                      expression: "vueProduitComplementaire.pcb"
                    }
                  }),
                  _c("v-select", {
                    staticStyle: { "margin-left": "2px", width: "200px" },
                    attrs: {
                      disabled: !_vm.mercurialeModifiable,
                      id: "selUC",
                      options: _vm.optionsUC,
                      value: "id",
                      label: "nom",
                      clearable: false
                    },
                    on: {
                      input: function($event) {
                        _vm.selectUCDeProduit($event)
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.ucSelect,
                      callback: function($$v) {
                        _vm.ucSelect = $$v
                      },
                      expression: "ucSelect"
                    }
                  })
                ],
                1
              ),
              !_vm.vueProduitComplementaire.pcb || !_vm.ucSelect.id
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ces champs sont requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("P.U. HT")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("InputNumber", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Prix Unitaire (selon PCB)",
                          placement: "top"
                        },
                        expression:
                          "{ content: 'Prix Unitaire (selon PCB)', placement: 'top' }"
                      }
                    ],
                    attrs: {
                      disabled: !_vm.mercurialeModifiable,
                      typeFiltre: "montant"
                    },
                    on: {
                      input: function($event) {
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.vueProduitComplementaire.prixUnitaireHT,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.vueProduitComplementaire,
                          "prixUnitaireHT",
                          $$v
                        )
                      },
                      expression: "vueProduitComplementaire.prixUnitaireHT"
                    }
                  }),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("€" + _vm._s(this.unitePrix(1)))
                    ])
                  ])
                ],
                1
              ),
              !_vm.vueProduitComplementaire.prixUnitaireHT
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Montant HT")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [_vm._v(" " + _vm._s(_vm.montantHT) + " ")]
              ),
              _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-1 form-group" })
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Taux TVA")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("v-select", {
                    staticStyle: { "margin-left": "2px", width: "200px" },
                    attrs: {
                      disabled: !_vm.mercurialeModifiable,
                      id: "selTVA",
                      options: _vm.optionsTVA,
                      value: "id",
                      label: "nom",
                      clearable: false
                    },
                    on: {
                      input: function($event) {
                        _vm.selectTVA($event)
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.tvaSelect,
                      callback: function($$v) {
                        _vm.tvaSelect = $$v
                      },
                      expression: "tvaSelect"
                    }
                  }),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(" %")
                    ])
                  ])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("P.U. TTC")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.puTTC) +
                      " €" +
                      _vm._s(this.unitePrix(1)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Montant TTC")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [_vm._v(" " + _vm._s(_vm.montantTTC) + " ")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "container-fluid card card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 form-group" }, [
              _c("label", [_vm._v("Paramétrage pour les recettes")])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-1 form-group" }),
            _c("div", { staticClass: "col-10 form-group" }, [
              _c("p", [_vm._v("Contenu du produit :")]),
              _vm.vueProduitComplementaire.pcb && _vm.ucSelect.id
                ? _c("div", { staticClass: "flex-center-center" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          "Dans " +
                            _vm._s(_vm.vueProduitComplementaire.pcb) +
                            " " +
                            _vm._s(
                              _vm.plurielUC(
                                _vm.vueProduitComplementaire.pcb,
                                _vm.vueProduitComplementaire.uc
                              )
                            ) +
                            " je vais avoir "
                        )
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.vueProduitComplementaire.nbPCE,
                          expression: "vueProduitComplementaire.nbPCE"
                        }
                      ],
                      staticClass: "saisieRepartition form-control",
                      staticStyle: {
                        margin: "2px",
                        width: "65px",
                        "text-align": "right"
                      },
                      attrs: { type: "number" },
                      domProps: { value: _vm.vueProduitComplementaire.nbPCE },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.vueProduitComplementaire,
                              "nbPCE",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.plurielUC(
                              _vm.vueProduitComplementaire.nbPCE,
                              "Pièce"
                            ) + ", "
                          )
                        )
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.vueProduitComplementaire.nbKg,
                          expression: "vueProduitComplementaire.nbKg"
                        }
                      ],
                      staticClass: "saisieRepartition form-control",
                      staticStyle: {
                        margin: "2px",
                        width: "65px",
                        "text-align": "right"
                      },
                      attrs: { type: "number" },
                      domProps: { value: _vm.vueProduitComplementaire.nbKg },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.vueProduitComplementaire,
                              "nbKg",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v("Kg, ")
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.vueProduitComplementaire.nbL,
                          expression: "vueProduitComplementaire.nbL"
                        }
                      ],
                      staticClass: "saisieRepartition form-control",
                      staticStyle: {
                        margin: "2px",
                        width: "65px",
                        "text-align": "right"
                      },
                      attrs: { type: "number" },
                      domProps: { value: _vm.vueProduitComplementaire.nbL },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.vueProduitComplementaire,
                              "nbL",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.plurielUC(
                              _vm.vueProduitComplementaire.nbL,
                              "Litre"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                : _c(
                    "span",
                    { staticClass: "input-group-text flex-center-center" },
                    [_vm._v("Veuillez renseigner le PCB")]
                  ),
              _c(
                "div",
                {
                  staticClass: "flex-center-center",
                  staticStyle: { height: "50px" }
                },
                [
                  _vm.repartitionOK &&
                  _vm.vueProduitComplementaire.pcb && _vm.ucSelect.id
                    ? _c("div", [
                        _c("em", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.phraseConversion(
                                  _vm.vueProduitComplementaire,
                                  _vm.vueProduitComplementaire,
                                  _vm.vueProduitComplementaire.pcb
                                ) || "Pas de répartition."
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.phraseConversion(
                                  _vm.vueProduitComplementaire,
                                  _vm.vueProduitComplementaire,
                                  1.5 * _vm.vueProduitComplementaire.pcb
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm.vueProduitComplementaire.pcb && _vm.ucSelect.id
                    ? _c("div", [
                        _c("em", [_c("p", [_vm._v("Pas de répartition.")])])
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _c("div", { staticClass: "col-1 form-group" })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }